import React from 'react';

import { isCommunitiesAllowed, isSpacesFeatureEnabled } from '@lumapps/communities/ducks/selectors';
import { useSelector } from '@lumapps/redux/react';
import { createSelector } from '@lumapps/redux/reselect';

import { SpacesSideNavigation as SpacesSideNavigationUI } from './SpacesSideNavigation';

const stateSelector = createSelector([isCommunitiesAllowed, isSpacesFeatureEnabled], (isAllowed, isFeatureEnabled) => ({
    isAllowed: isAllowed && isFeatureEnabled,
}));

export const SpacesSideNavigation: React.FC = (props) => {
    const { isAllowed } = useSelector(stateSelector);

    return <SpacesSideNavigationUI {...props} isAllowed={isAllowed} />;
};

SpacesSideNavigation.displayName = 'SideNavigationItem';
